import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./aboutUs.css";

const ResponsiveComponent = () => {
  const ref = useRef();
  const [hasScrolledIntoView, setHasScrolledIntoView] = useState(false);
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false); // Track refresh state

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasScrolledIntoView(true);
        }
      },
      { threshold: 0.2 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
      observer.disconnect();
    };
  }, []);

  const handleNavigation = () => {
    // Trigger a refresh by setting state
    setRefresh(true);
    navigate("/courses");
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setRefresh(false); // Reset the refresh state after navigation
    }, 100); // Delay to ensure the navigation happens first
  };

  return (
    <div
      ref={ref}
      className={`responsive-container-block bigContainer ${
        hasScrolledIntoView ? "enter" : ""
      }`}
    >
      <div className="responsive-container-block Container">
        <img
          className="mainImg"
          src={require("./pictures/home1.jpeg")}
          alt="Punjabi Learning"
        />
        <div className="allText aboveText">
          <p className="text-blk headingText">Our Mission</p>
          <p className="text-blk subHeadingText">
            Preserving and Promoting Punjabi
          </p>
          <p className="text-blk description">
            At our Punjabi teaching platform, we are dedicated to spreading the
            beauty of Punjabi language, culture, and heritage. Our mission is
            to empower individuals of all ages to connect with their roots,
            express themselves fluently, and cherish the rich traditions of
            Punjab.
          </p>
          <button className="explore" onClick={handleNavigation}>
            Start Learning
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResponsiveComponent;
